<template>
	<div>	
		<ConfirmModal id="top_bar_signout_modal" v-if="showConfirmModal" @confirm="signout()" @cancel="showConfirmModal=false" title="Confirm sign out" message='You will be logged out of this account.' confrimationModalButtonText="Sign out"/>
		<nav class="h-14 w-full flex justify-end pr-6">
			<div class="text-gray-600 flex justify-left items-start gap-x-3 absolute z-20" id="top_nav_bar_dropdown">
                <div v-if="devMode === 'false'" class="border-2 border border-green-500 bg-green-50 h-12 flex items-center gap-2 mt-1 rounded-lg pl-4 pr-4">
                    <p class="text-green-600 text-sm font-semibold">In development mode</p>
                </div>
                <!--If sandbox mode is optional-->
                <!--If sandbox mode is not-optional-->
                <div v-if="showSandboxOnly" class="border-2 border border-orange-500 bg-orange-50 h-12 flex items-center gap-2 mt-1 rounded-lg pl-4 pr-4">
                    <p class="text-orange-600 text-sm font-semibold ']">
                        Sandbox mode
                        
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-blocks text-orange-600"><rect width="7" height="7" x="14" y="3" rx="1"/><path d="M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"/></svg>
                </div>

                <div v-else-if="nonSandboxPages">
                <div v-if="customerContract != 'NOT_IN_CONTRACT' ">
                    <div :class="[testMode ? 'border-2 border border-orange-500 bg-orange-50' : 'border-2 border-dashed border-gray-300', 'h-12 flex items-center gap-2 mt-1 rounded-lg pl-4 pr-4']">
                    <p :class="[testMode ? 'text-orange-600' : 'text-gray-600', 'text-sm font-semibold ']">
                        Sandbox mode
                    </p>
                    <CustomToggle
                        @click="toggleSandbox()"
                        :toggleOn="testMode"
                    />
                    </div>
                </div>
                <div v-else-if="preLaunchApprovedPages == true">
                    <div :class="[testMode ? 'border-2 border border-orange-500 bg-orange-50' : 'border-2 border-dashed border-gray-300', 'h-12 flex items-center gap-2 mt-1 rounded-lg pl-4 pr-4']">
                    <p :class="[testMode ? 'text-orange-600' : 'text-gray-600', 'text-sm font-semibold ']">
                        Sandbox mode
                    </p>
                    <CustomToggle
                        @click="toggleSandbox()"
                        :toggleOn="testMode"
                    />
                    </div>
                </div>



                <div v-else class="border-2 border border-orange-500 bg-orange-50 h-12 flex items-center gap-2 mt-1 rounded-lg pl-4 pr-4">
                    <p class="text-orange-600 text-sm font-semibold ']">
                        Sandbox mode
                        
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-blocks text-orange-600"><rect width="7" height="7" x="14" y="3" rx="1"/><path d="M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"/></svg>
                </div>
                </div>
                <Dropdown
                    id="top_bar_dropdown"
                    :title='email'
                    :links="[
                        {text: 'Settings', title:'Settings', icon: 'Cog'},
                        {text: 'Sign out', title:'Sign_out', icon: 'LogOut'}
                    ]"
                    @Settings="$router.push('/settings')"
                    @Sign_out="showConfirmModal=true"

                    class="z-40 mt-4 lg:mt-0 h-12"
                /><!---->
			</div>
		</nav>
        <main class="lg:pl-[250px]">
            <div v-if="nonSandboxPages && testMode" class="border-t-2 border-orange-500 bg-gradient-to-b from-orange-50 to-transparent  pb-3 w-full flex justify-center mt-3 -mb-3">
			<div class="bg-orange-500 px-3 rounded-b">
				<p class="text-xs font-semibold text-white capitalize">TEST DATA</p>
			</div>
		</div>
			</main>
        
	</div>
</template>

<script>
import Dropdown from '@/components/navbars/Dropdown.vue';
import ConfirmModal from '@/components/modals/ConfirmModal';
import CustomToggle from '@/components/inputs/CustomToggle.vue';

export default {
    name: "TopBar",
    components: {
        Dropdown,
		ConfirmModal,
        CustomToggle
    },
    data() {
        return {
			email: localStorage.getItem('firstName') + " " + localStorage.getItem('lastName') ,
			showConfirmModal: false,
            testMode: localStorage.getItem('apiType') == process.env.VUE_APP_SANDBOX_API ,
            devMode: process.env.VUE_APP_PRODUCTION ,
            sandboxOnly: localStorage.getItem('sandbox') == "true",
            notInContract: false
        }
    },
    mounted() {
  window.addEventListener('foo-key-localstorage-changed', (event) => {
    this.email = event.detail.storage;
  });
    
},

    computed: {
        brandName() {
            return "Test brand"
        },

        showSandboxOnly(){
            // var publisherStatus = localStorage.getItem('publisherStatus') // 
            return this.sandboxOnly == true
        },

        nonSandboxPages(){
            var route = this.$route.fullPath
            if(route!= '/launchpad' && route!= '/settings'  && route!= '/billing' ){
                return true
            }
            else{
                return false
            }
        },

        preLaunchApprovedPages(){
            var route = this.$route.fullPath
            if(route.includes('/retailer-catalogue') || route.includes('/program-offers')  || route.includes('/retailer-approvals')  ){
                return true
            }
            else{
                return false
            }
        },
        
        customerContract(){
            var contract = localStorage.getItem('publisherStatus')
            return contract
        }



    },
    methods: {

        toggleSandbox(){
            if(this.testMode)
            {
                localStorage.setItem("apiType",process.env.VUE_APP_DEFAULT_API)
                this.testMode = localStorage.getItem('apiType') == process.env.VUE_APP_SANDBOX_API

            }
            else
            {
                localStorage.setItem("apiType",process.env.VUE_APP_SANDBOX_API)
                this.testMode = localStorage.getItem('apiType') == process.env.VUE_APP_SANDBOX_API 
            }
            this.$router.go(0);
        },

        signout(){
            localStorage.clear();
            this.$router.push("/auth/sign-in")
        }

    },

}
</script>